/** @format */

export { defaultDocumentOptions } from './helpers/options';
export { getRenderers } from './helpers/renderer';
export {
    contentfulSitewideBannerDataToSitewideBanner,
    contentfulContentAreaToAccountSplashPage,
    contentfulEntryHyperlinkToWrappedLink,
    renderContentfulCategoryContent,
    contentfulLandingPageDataToContentBlocks,
    transformLandingPageCollection,
    contentfulBasicPageDataToContentBlocks,
    siteModalToConditionsModal,
    siteModalToModal,
    siteModalToQuestionModal,
    siteHeaderToHeroBlock,
    transformSiteContentHeader,
    contentfulArticleCardDataToArticleCard,
    contentfulCategoryDataToCategoryCard,
    contentfulVideoBlockToVideoBlock,
} from './helpers/adapters/contentful';

export * from './components/image-compare';
export * from './components/image-with-caption';
export * from './components/masonry-grid';
export * from './components/bold';
export * from './components/caption';
export * from './components/heading';
export * from './components/link';
export * from './components/picture';
export * from './components/embedded-script';
export * from './components/blockquote';
export * from './components/embedly';
export * from './components/condition-modal-content';
export * from './components/contentful-articles';
export * from './components/original-content-header';
export * from './components/content-block-collection';
export * from './components/content-collection';
export * from './components/section-preview-block';
export * from './components/story-card';
export * from './components/video-block';
export * from './components/article-results';
export * from './components/article-carousel';
export * from './components/category-block';
export * from './components/category-tile';
export * from './components/join-now-tile';
export * from './components/social-footer';
export * from './components/article-tile';
export * from './components/block-title';
export * from './components/blurred-article-tile';
export * from './components/category-block/types';
export * from './hooks/use-page-data';

export {
    type LandingPageContentResponse,
    LandingPageHeroRenderType,
    type LandingPageData,
} from './config/page-data';
export { getAuthorFullName, getAuthorPageSlug } from './helpers/author';
export { getContentfulLinkDetails, getUrlSlugs } from './helpers/contentful';
export {
    useAuthorPagePath,
    type UseAuthorPagePathReturn,
} from './hooks/use-author-page-path';
export { useContentfulMeta } from './hooks/use-contentful-meta';
export { type ArticlePageData, type ArticlePageProps } from './config/types';
export * from './components/author-credit';
export * from './components/featured-articles-block';
export * from './hooks/use-author-credit';
